/** Stub: gyro-driven plumb deferred on MFV-UI/UX-June26 (see docs/deferred/MFV-UI-UX-June26-deferred-cherry-picks.md). */
export function useDeviceOrientation() {
  return {
    tilt: null as { gamma: number; beta: number } | null,
    permission: 'unsupported' as const,
    requestPermission: async () => false,
  };
}
